import React from 'react';
import { Box } from '@mui/material';
import { TicketProvider } from '@/context/TicketContext';
import ChildCard from '@/components/shared/ChildCard.tsx';
import TicketFilter from '@/components/tickets/TicketFilter.tsx';
import TicketListing from '@/components/tickets/TicketListing.tsx';

const TicketsPage: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <TicketProvider>
        <ChildCard>
          <TicketFilter />
          <TicketListing />
        </ChildCard>
      </TicketProvider>
    </Box>
  );
};

export default TicketsPage;
